export const loadSVG = async (pack: string, icon: string) => {
	if (Array.isArray(pack)) {
		pack = pack[0]
	}
	
	return (await import(`../assets/icons/${pack}/${icon}.svg?raw`)).default
}